import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { fetchActiveNotes, deleteNote, toggleCreateNoteForm } from 'services/annotations/duck';
import { ANNOTATION_READ } from 'constants/capabilities';
import DashboardNotesList from 'components/organisms/annotations/DashboardNotesList';
import ProtectedComponent from 'hoc/ProtectedComponent';

function NoteContainer(props) {
    const {
        entityId,
        dashboard,
        notes,
        start,
        end,
        showCreateForm,
    } = props;

    useEffect(
        () => {
            props.fetchActiveNotes({
                entityId,
                start,
                end
            });
            return () => {
                props.toggleCreateNoteForm(false);
            };
        },
        [entityId, start, end]
    );

    return (
        <DashboardNotesList
            notes={notes}
            dashboard={dashboard}
            handleToggle={props.toggleCreateNoteForm}
            showCreateForm={showCreateForm}
            entityId={entityId}
            deleteNote={props.deleteNote}
            fluid />
    );
}


NoteContainer.propTypes = {
    handleDelete: PropTypes.func,
    entityId: PropTypes.number.isRequired,
    exportName: PropTypes.string
};

const ProtectedNoteContainer = ProtectedComponent({ requiredCapabilities: [ANNOTATION_READ] })(NoteContainer);

const mapStateToProps = (state, props) => ({
    notes: get(state, `annotations.notes.${props.dashboard}`, []),
    showCreateForm: get(state, 'annotations.showCreateForm', false)
});

export default connect(mapStateToProps, {
    fetchActiveNotes,
    deleteNote,
    toggleCreateNoteForm
})(ProtectedNoteContainer);



// WEBPACK FOOTER //
// ./src/containers/annotations/NoteContainer.js